/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whatsapp_Bot_Link_HelpInputs */

const he_whatsapp_bot_link_help = /** @type {(inputs: Whatsapp_Bot_Link_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לחצו על הקישור מאתר pricedrop כדי לחבר את החשבון שלכם`)
};

const en_whatsapp_bot_link_help = /** @type {(inputs: Whatsapp_Bot_Link_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap the link from the pricedrop website to link your account`)
};

/**
* | output |
* | --- |
* | "Tap the link from the pricedrop website to link your account" |
*
* @param {Whatsapp_Bot_Link_HelpInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const whatsapp_bot_link_help = /** @type {((inputs?: Whatsapp_Bot_Link_HelpInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whatsapp_Bot_Link_HelpInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_whatsapp_bot_link_help(inputs)
	return en_whatsapp_bot_link_help(inputs)
});